import i from "./td-longtail-vue-components109.js";
/* empty css                              */
import o from "./td-longtail-vue-components98.js";
var n = function() {
  var e = this, t = e._self._c, s = e._self._setupProxy;
  return t("picture", [e._l(s.sourcesWithBreakpointReverse, function(r, a) {
    return t("source", { key: `${r.name}-${a}`, attrs: { srcset: r.src, media: r.media, type: r.type } });
  }), t("img", { key: e.src || "", class: e.imageClass, style: e.imageStyle, attrs: { src: s.defaultImage?.src, alt: e.alt || "", height: e.height, width: e.width, loading: e.lazy ? "lazy" : void 0 }, on: { error: function(r) {
    return e.$emit("image-error", r);
  } } })], 2);
}, c = [], m = /* @__PURE__ */ o(
  i,
  n,
  c,
  !1,
  null,
  "b8487100"
);
const p = m.exports;
export {
  p as default
};
